import varAxios from "../../Comman/axios";
import { VerifyCode,VerifyEmailSMSOTP,CommonAuthenticatorMethod,ActivateAuthAppUser,GetQRCodeForAuthRegistration,GetCompanyBrandingList,superadminLoginUrl, setLanguageUrl, getLanguageUrl } from "../../Comman/apiEndPoints"
import decode from 'jwt-decode';

export const FETCH_SUPER_ADMIN_LOGIN_REQUEST = "(superadminLogin) FETCH SUPER ADMIN LOGIN REQUEST";
export const FETCH_SUPER_ADMIN_LOGIN_SUCCESS = "(superadminLogin) FETCH SUPER ADMIN LOGIN SUCCESS";
export const FETCH_SUPER_ADMIN_LOGIN_ERROR = "(superadminLogin) FETCH SUPER ADMIN LOGIN ERROR";
export const LOGOUT_SUPER_ADMIN_REQUEST = "(adminLogout) LOGOUT ADMIN REQUEST"
export const GET_COMPANY_REQUEST = "GET_COMPANY_REQUEST";
export const APPLICATION_REQUEST="APPLICATION_REQUEST";
export const ADD_COMPANY_REQUEST= "ADD_COMPANY_REQUEST";

export const APPLICATION_ADDAUTH="APPLICATION_ADDAUTH";
export const ADD_ADDAUTH= "ADD_ADDAUTH";

export const APPLICATION_ACTIVATEAUTH="APPLICATION_ACTIVATEAUTH";
export const ADD_ACTIVATEAUTH= "ADD_ACTIVATEAUTH";

export const APPLICATION_COMMONMETHOD="APPLICATION_COMMONMETHOD";
export const ADD_COMMONMETHOD= "ADD_COMMONMETHOD";

export const APPLICATION_VAUTHOTP="APPLICATION_VAUTHOTP";
export const ADD_VAUTHOTP= "ADD_VAUTHOTP";

export const APPLICATION_EAUTPOTP="APPLICATION_EAUTPOTP";
export const ADD_EAUTPOTP= "ADD_EAUTPOTP";
export function getVerifyEmailSMSOTP(data) {
    
    return (dispatch) => {
      dispatch(ApplicationVerifyEmailSMSOTP(true)); 

        return varAxios.post(VerifyEmailSMSOTP,data, JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               
              dispatch(
                 fetchgetVerifyEmailSMSOTPSuccessData(
                false,
            response.data.errorCode,
            response.data.errorMessage,
               response.data.statusCode,
                response.data.isCodeVerified
            )
              );
                 return Promise.resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                return Promise.resolve(error);
            })
    }
  }
 export function ApplicationVerifyEmailSMSOTP(isLoading){
    return {
      type : APPLICATION_EAUTPOTP,
      isLoading
    }
  }
export function fetchgetVerifyEmailSMSOTPSuccessData(isLoading,errorCode,errorMessage,statusCode,isCodeVerified) {
    
    return {
        type : ADD_EAUTPOTP,
       isLoading,
      errorCode,
      errorMessage,
      statusCode,
     isCodeVerified
    }
}
export function getVerifyCode(data) {
    
    return (dispatch) => {
      dispatch(ApplicationVerifyCode(true)); 

        return varAxios.post(VerifyCode,data, JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               
              dispatch(
                 fetchgetVerifyCodeSuccessData(
                false,
            response.data.errorCode,
            response.data.errorMessage,
               response.data.statusCode,
                response.data.isCodeVerified
            )
              );
                 return Promise.resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                return Promise.resolve(error);
            })
    }
  }
 export function ApplicationVerifyCode(isLoading){
    return {
      type : APPLICATION_VAUTHOTP,
      isLoading
    }
  }
export function fetchgetVerifyCodeSuccessData(isLoading,errorCode,errorMessage,statusCode,isCodeVerified) {
    
    return {
        type : ADD_VAUTHOTP,
       isLoading,
      errorCode,
      errorMessage,
      statusCode,
     isCodeVerified
    }
}
export function getCommonAuthenticatorMethod(data) {
    
    return (dispatch) => {
      dispatch(ApplicationCommonAuthenticatorMethod(true)); 

        return varAxios.post(CommonAuthenticatorMethod,data, JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               
              dispatch(
                 fetchgetCommonAuthenticatorMethodSuccessData(
                false,
            response.data.errorCode,
            response.data.errorMessage,
               response.data.statusCode,
                response.data.removeAccountObject
            )
              );
                 return Promise.resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                return Promise.resolve(error);
            })
    }
  }
 export function ApplicationCommonAuthenticatorMethod(isLoading){
    return {
      type : APPLICATION_COMMONMETHOD,
      isLoading
    }
  }
export function fetchgetCommonAuthenticatorMethodSuccessData(isLoading,errorCode,errorMessage,statusCode,removeAccountObject) {
    
    return {
        type : ADD_COMMONMETHOD,
       isLoading,
      errorCode,
      errorMessage,
      statusCode,
      removeAccountObject
    }
}
export function getActivateAuthAppUser(data) {
    
    return (dispatch) => {
      dispatch(ApplicationActivateAuthAppUser(true)); 

        return varAxios.post(ActivateAuthAppUser,data, JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
               
              dispatch(
                 fetchgetActivateAuthAppUserSuccessData(
                false,
            response.data.errorCode,
            response.data.errorMessage,
               response.data.statusCode,
                response.data.activateAppUserSucceeded
            )
              );
                 return Promise.resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
                return Promise.resolve(error);
            })
    }
  }
 export function ApplicationActivateAuthAppUser(isLoading){
    return {
      type : APPLICATION_ACTIVATEAUTH,
      isLoading
    }
  }
export function fetchgetActivateAuthAppUserSuccessData(isLoading,errorCode,errorMessage,statusCode,activateAppUserSucceeded) {
    
    return {
        type : ADD_ACTIVATEAUTH,
       isLoading,
      errorCode,
      errorMessage,
      statusCode,
      activateAppUserSucceeded
    }
}


export function getQRCodeForAuthRegistration(data) {
    return (dispatch) => {
      dispatch(ApplicationAddAuth(true)); 

        return varAxios.post(GetQRCodeForAuthRegistration,data, JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
             
              dispatch(
                 fetchgetQRCodeForAuthRegistrationSuccessData(
                false,
            response.data.errorCode,
               response.data.statusCode,
                response.data.authAppUser
            )
              );
              return Promise.resolve(response.data);
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
 export function ApplicationAddAuth(isLoading){
    return {
      type : APPLICATION_ADDAUTH,
      isLoading
    }
  }
export function fetchgetQRCodeForAuthRegistrationSuccessData(isLoading,errorCode,statusCode,authAppUser) {
  
    return {
        type : ADD_ADDAUTH,
       isLoading,
      errorCode,
      statusCode,
      authAppUser
    }
}
export function getCompanyBrandingList() {
    return (dispatch) => {
      dispatch(ApplicationRequest(true)); 

        return varAxios.get(GetCompanyBrandingList)
            .then((response) => {
           
              dispatch(
                 fetchGetCompanyBrandingListSuccessData(
                false,
            response.data.errorCode,
               response.data.statusCode,
                response.data.brandlist
            )
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
 export function ApplicationRequest(isLoading){
    return {
      type : APPLICATION_REQUEST,
      isLoading
    }
  }
export function fetchGetCompanyBrandingListSuccessData(isLoading,errorCode,statusCode,brandList) {
   
    return {
        type : ADD_COMPANY_REQUEST,
       isLoading,
      errorCode,
      statusCode,
      brandList
    }
}
export function fetchAdminLoginRequest({ userName, isLoading, password }) {
    return {
        type: FETCH_SUPER_ADMIN_LOGIN_REQUEST,
        userName,
        isLoading,
        password
    }
}



export function fetchAdminLoginSuccess({ userName, isLoading, password, Message, loginStatus, authTokenId, userId,loginDetails }) {
    return {
        type: FETCH_SUPER_ADMIN_LOGIN_SUCCESS,
        userName,
        isLoading,
        password,
        Message,
        loginStatus,
        authTokenId,
        userId,
        loginDetails
    }
}

export function fetchAdminLoginError({isLoading, Message,loginStatus }) {
    return {
        type: FETCH_SUPER_ADMIN_LOGIN_ERROR,
        isLoading,
        Message,
        loginStatus    
    }
}

export function superAdminLogin(userName, password, dispatch) {
    let data = {
        EmailId: userName,
        Password: password
    }

    return (dispatch) => {
        dispatch(fetchAdminLoginRequest({ userName: userName, isLoading: true, password: password }));
        return varAxios.post(superadminLoginUrl, data,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              
                dispatch(
                    fetchAdminLoginSuccess({
                        userName: response.data.superAdmin.Username, 
                        isLoading: false, 
                        password: password,
                        Message: response.data.errorMessage, 
                        loginStatus: response.data.statusCode,
                        authTokenId: response.data.authToken, 
                        userId: response.data.superAdmin.UserId,
                        loginDetails:response.data.superAdmin
                    }));
                //setToken(response.data.authToken,response.data.superAdmin.UserId,response.data.superAdmin.Username, response.data.superAdmin.OrganizationId,response.data.superAdmin.rolePermission,response.data.superAdmin.UserType) // Setting the token in localStorage
                return Promise.resolve(response.data);
            })
            .catch((error) => {
                dispatch( fetchAdminLoginError({
                        isLoading: false, 
                        Message: error.response.data.superAdmin, 
                        loginStatus:error.response.data.statusCode
                        
                    }));
            })

    }
}



export function logOutAdminRequest({ userName, isLoading, password, Message, loginStatus, authTokenId, userId }) {
    return {
        type: LOGOUT_SUPER_ADMIN_REQUEST,
        userName,
        isLoading,
        password,
        Message,
        loginStatus,
        authTokenId,
        userId,

    }
}

export function logOutAdmin() {
    return (dispatch) => {
        dispatch(logOutAdminRequest({ userName: "", isLoading: false, password: "", Message: "", loginStatus: 0, authTokenId: "", adminId: 0 }));
    }
}

export function loggedIn(authTokenId) {
    // Checks if there is a saved token and it's still valid 
    const token = getToken() // GEtting token from localstorage
    
    /*if (token !== authTokenId)
        return false;
    else*/
        return !!token && !isTokenExpired(token) // handwaiving here
}

function isTokenExpired(token) {
    try {
        const decoded = decode(token);
        if (decoded.exp < Date.now() / 1000) { // Checking if token is expired. N
            return true;
        }
        else
            return false;
    }
    catch (err) {
        return false;
    }
}

function setToken(idToken,userId,userName,orgId,PermissionId,UserType) {
    
    // Saves user token to localStorage
    sessionStorage.setItem('id_super_admin_token', idToken);
    sessionStorage.setItem('SuperAdminUserID', userId);
    sessionStorage.setItem('SuperAdminUserName', userName);
    sessionStorage.setItem('OrganizationId', orgId);
    sessionStorage.setItem('Permissions', JSON.stringify(PermissionId));
    sessionStorage.setItem('UserType', UserType);
    sessionStorage.setItem('Time', new Date());
    localStorage.removeItem('id_admin_token');
    localStorage.removeItem('OrganizationID');
    localStorage.removeItem('userid_token');
    localStorage.removeItem('UserID');
    
    
}

export function getToken() {
    // Retrieves the user token from localStorage
    return sessionStorage.getItem('id_super_admin_token')
}

export function logout() {
    // Clear user token and profile data from localStorage
    sessionStorage.removeItem('id_super_admin_token');
    sessionStorage.removeItem('SuperAdminUserID'); 
    sessionStorage.removeItem('SuperAdminUserName');
    sessionStorage.removeItem('Time');
    sessionStorage.removeItem('Permissions');
    sessionStorage.removeItem('UserType');
    localStorage.clear(); 
}

export function getProfile() {
    // Using jwt-decode npm package to decode the token
    return decode(getToken());
}

export function setTranslateLang(lang){
    let requestPayload = {
        Language : lang
    }
    return (dispatch) => {
        return varAxios.post(setLanguageUrl, requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                if(response.data.statusCode == 200){
                    var language;
                    if(lang == "Swedish"){
                        language = "sv"
                    }
                    else{
                        language = "en"
                    }
                    sessionStorage.setItem('Language',language)                    
                }  
            })
            .catch((error) => {
                console.log(error)
            })
    }
}

export function getTranslateLang(){
    return (dispatch) => {
        return varAxios.post(getLanguageUrl, {},
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
                if(response.data.statusCode == 200){
                    var language;
                    if(response.data.globalizationLanguage.Language == "Swedish"){
                        language = "sv"
                    }
                    else{
                        language = "en"
                    }
                    sessionStorage.setItem('Language',language)                    
                }  
            })
            .catch((error) => {
                console.log(error)
            })
    }
}

